export enum ActionType {
  BE_RLD_COST_UPDATE = "BE_RLD_COST_UPDATE",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IBeRLDCostProjectDetails {
  type: ActionType.BE_RLD_COST_UPDATE;
  payload: any[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IBeRLDCostProjectDetails | IResetReduxState;
